export default {
	type: 'object',
	properties: {
		doGiveaways: { type: 'boolean' },
		twitchIdPermission: { type: 'boolean' },
	},
}
